import styled from 'styled-components';
import { Form as UForm } from '@unform/web';

export const Form = styled(UForm)`
  width: 100%;
`;
